

import { Component, OnInit, Input } from '@angular/core';
import { SetService, HttpService, JwtService } from 'ngx-block-core';
import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { NzModalService, NzMessageService, UploadFile } from 'ng-zorro-antd';
import { selectSize, selectThemeSize, iconTheme, eventTypeInput } from "../../../data/data";
import { fileType, fileUploadType } from "../../../data/data";
import * as Excel from "exceljs/dist/exceljs.min.js";
@Component({
    selector: 'app-sucu05-button0020003',
    templateUrl: './sucu05-button0020003.component.html',
})
export class Sucu05Button0020003Component implements OnInit {

    isVisible = false;
    fileList = []
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() sets = {
        blockName: "导入按钮",
        blockId: "",
        layoutId: "",
        blockType: 'formButton',
        blockChildType: '',
        versionCode: 8,
        events :[
            {
                label: "隐藏",
                value: "pageShow",
                data: {
                    setParams: ["隐藏值", '显示值，可不填', '备用']
                }
            },

        ],
        styles: {
            nzText: "导入",
            nzTemplateName: "",
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },
            nzOpen: true,
            nzConfirm: {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定吗？"
            },
            nzMode: '0',//0-导入，1-excel拿值
            nzSetValueId: "",
            nzAccept: "",
            nzTipText: "",
            nzShow:true
        },
        datas: {
            importId: "",
            importModel: "0",
            nzDataSource: "",
            nzFileName: "",
            nzFileInformation: [],
            nzClickField: [],
            nzJumpType: "self",
            nzJumpPageType: 0,
            nzJumpPage: "",
            nzSenceSelectValue: [],
            nzSenceValue: [],
            nzVirtualSenceSelectValue: [],
            nzVirtualSenceValue: [],
            nzSenceJson: [],
            nzEvents: [

            ],
            nzEventsDatas: {
            },
        }
    };
    setData = [
        {
            tabName: '数据',
            datas: [
                {
                    type: 'styles',
                    data: [
                        {
                            name: 'upload',
                        },
                        {
                            name: 'input',
                            inputs: {
                                nzText: "模板名称 : ", nzKeys: ['styles', 'nzTemplateName'],
                                nzPlaceHolder: "模板.xlsx", nzPopContent: "需要写后缀名，不写则不提供下载"
                            }

                        },
                        {

                            name: 'select',
                            inputs: {
                                nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: [{ value: '0', label: '导入' }, { value: '1', label: 'excel取值' }]

                            }
                        },
                        {
                            name: 'select',
                            inputs: { nzText: "取值积木 : ", nzKeys: ['styles', 'nzSetValueId'], nzData: this.setService.getBlock('formBlock', "*") ,nzPopContent:"模式为取值时，需要配置取值积木"},
                            
                        },
                        {
                            name: 'select',
                            inputs: { nzText: "文件类型 : ", nzKeys: ['styles', 'nzAccept',], nzData: fileType, nzMode: 'multiple' },
                        },
                        {
                            name: 'input',
                            inputs: {
                              nzText: "提示信息 : ", nzKeys: ['styles', 'nzTipText'], nzType: "textarea",
                              nzAutosize: { minRows: 3, maxRows: 6 },
                            }
                          },
                        

                    ]
                }
            ]
        },
        {
            tabName: '样式',
            datas: [
                {
                    type: 'styles',
                    data: [
                        {
                            name: 'input',
                            inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                        },
                        {
                            name: 'input',
                            inputs: {
                                nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                            }

                        },


                        {

                            name: 'select',
                            inputs: {
                                nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                            }
                        },
                        {
                            name: 'radio',
                            inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                            outputs: {
                                ngModelChange: (event) => {


                                    if (event == 'twotone') {

                                        this.setService.setDatas[this.blockid][2]['datas'][0]['data'][4]['show'] = true;

                                    } else {
                                        this.setService.setDatas[this.blockid][2]['datas'][0]['data'][4]['show'] = false;

                                    }


                                    this.setService.onReLoadbBlock(this.layoutid);

                                }
                            }
                        },
                        {
                            name: 'input',
                            inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                            outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                        },
                        {
                            name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                            inputs: {
                                nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                            }
                        },

                        {
                            name: 'color',
                            inputs: {
                                nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                            }
                        },
                        {
                            name: 'radio',
                            inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                        },
                        {
                            name: 'switch',
                            inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
                        },
                        {
                            name: 'switch',
                            inputs: { nzText: "显示按钮 : ", nzKeys: ['styles', 'nzShow'] }
                        },
                        { name: 'nzConfirm' }
                    ]
                },
            ]
        },
        {
            tabName: '功能',
            datas: [
                {
                    type: 'datas',
                    data: [
                        { name: "nzEvents", inputs: { eventType: eventTypeInput } },
                    ]
                },
            ]
        },
        // {
        //     tabName: '功能',
        //     datas: [

        //         {
        //             type: 'datas',
        //             data: [
        //                 {
        //                     name: 'select',
        //                     inputs: {
        //                         nzText: "导入模式 : ", nzKeys: ['datas', 'importModel'], nzData: importModel
        //                     }
        //                 }

        //             ]
        //         },
        //     ]
        // },
    ]



    constructor(
        public setService: SetService,
        private httpService: HttpService,
        private modalService: NzModalService,
        private http: HttpClient,
        private message: NzMessageService,
        private jwtService: JwtService,

    ) { }
    nzShow=true;
    ngOnInit() {


        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.autoUpdate();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }


            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
        }
        this.nzShow=this.sets.styles.nzShow;
        this.Listening();
    }
    autoUpdate() {


        // V2 按钮开放
        if (this.sets.versionCode < 2) {

            this.sets.styles['nzOpen'] = true;

            this.sets.versionCode = 2;
        }
        // V5 按钮确认
        if (this.sets.versionCode < 3) {

            this.sets.styles['nzConfirm'] = {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定要删除吗？"
            };

            this.sets.versionCode = 3;
        }
        if (this.sets.versionCode < 4) {

            this.sets.datas['nzEvents'] = []
            this.sets.datas['nzEventsDatas'] = {}

            this.sets.versionCode = 4;
        }
        if (this.sets.versionCode < 5) {

            this.sets.styles['nzTemplateName'] = '';

            this.sets.versionCode = 5;
        }

        if (this.sets.versionCode < 8) {
            this.sets.styles['nzMode'] = '0';
            this.sets.styles['nzSetValueId'] = '';
            this.sets.styles['nzAccept'] = '';
            this.sets.styles['nzShow'] = true;
            this.sets.styles['nzTipText'] = '';
            this.sets.events = [
                {
                    label: "隐藏",
                    value: "pageShow",
                    data: {
                        setParams: ["隐藏值", '显示值，可不填', '备用']
                    }
                },

            ]
            this.sets.versionCode = 8;
        }
        


    }
    onClickEvents() {
        this.isVisible = true;
        console.log("data_import", this.sets.datas)

    }
    onClick(): void {
        if (!this.sets.styles.nzOpen) {
            this.message.create('info', `功能暂未开放`);
        } else {
            if (this.sets.styles.nzConfirm.nzShow) {
                this.modalService.confirm({
                    nzTitle: this.sets.styles.nzConfirm.nzTitle,
                    nzContent: this.sets.styles.nzConfirm.nzContent,
                    nzOnOk: () => this.onClickEvents()
                });
            }
            else {
                this.onClickEvents();
            }
        }

    }
    handleOk(): void {
        this.fileList = []
        this.isVisible = false;
    }

    handleCancel(): void {

        this.fileList = []
        this.isVisible = false;
    }
    handleChange(event): void {
        console.log("event", event)
    }
    beforeUpload = (file: UploadFile): boolean => {
        this.fileList = this.fileList.concat(file);
        return false;
    }
    uploading = false;
    upload() {
        //事件
        let endEvent = [];
        this.sets.datas.nzEvents.forEach(element => {
            switch (element) {

                case 'sendSimpleEvent':
                    this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                        if (itemEvents['order'] == "front") {
                            switch (itemEvents['name']) {
                                case 'search':
                                    break;
                                default:
                                    let senddata = { value: "" };
                                    try {
                                        senddata['param0'] = itemEvents['param0'];
                                        senddata['param1'] = itemEvents['param1'];
                                        senddata['param2'] = itemEvents['param2'];
                                    } catch (error) {

                                    }
                                    console.log("send-fast", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                    break;
                            }
                        } else {
                            if (endEvent.indexOf(element) < 0) endEvent.push(element);
                        }
                    });

                    break;

                default:
                    break;
            }
        });


        const formData = new FormData();
        // tslint:disable-next-line:no-any
        this.fileList.forEach((file: any) => {
            formData.append('files[]', file);
        });
        this.uploading = true;

        this.httpService.postHttp("/import/excel?sysExcelImportId=" + this.sets.datas.importId, formData).subscribe(
            (data: any) => {
                this.uploading = false;
                this.fileList = [];
                this.isVisible = false;
                try {
                    this.setService.sendEvent(this.sets.datas.nzDataSource, "simpleSearch")

                } catch (error) {
                    console.log("导入刷新失败", error)
                }
                this.message.success('上传成功');
                //事后事件处理
                endEvent.forEach(element => {
                    this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                        if (itemEvents['order'] == "back") {
                            switch (itemEvents['name']) {
                                case 'search':
                                    break;
                                default:
                                    let senddata = { value: "" };
                                    try {
                                        senddata['param0'] = itemEvents['param0'];
                                        senddata['param1'] = itemEvents['param1'];
                                        senddata['param2'] = itemEvents['param2'];
                                    } catch (error) {

                                    }
                                    console.log("send-fast", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                    break;
                            }
                        }


                    });
                });
            }, (err) => {
                this.uploading = false;
                this.message.error('上传有误');

            });
    }
    handleUpload(): void {
        if (this.sets.styles.nzMode === '0') {
            this.upload();
        } else {
            this.getFileValue();
        }

    }
    downLoad() {

        const url = this.jwtService.getUserResourceUrl() + '/importTemplate/' + this.sets.styles.nzTemplateName;
        console.log('downLoad', url);
        this.message.info('请下载');
        if (!this.static) {
            window.open('http://172.16.8.112:81/importTemplate/' + this.sets.styles.nzTemplateName);
            return;
        }
        window.open(url);

    }
    filevalue: string = ""
    //模板数据获取test
    getFileValue() {
        if (this.fileList.length === 0) {
            this.message.error('请选择文件');
            return;
        } else if (this.sets.styles.nzSetValueId == '') {
            this.message.error('未配置取值积木');
            return;
        }
        let file = this.fileList[0];
        console.log('file', file);
        let reader = new FileReader();
        reader.readAsArrayBuffer(file);
        let self = this;
        reader.onload = function (e: any) {
            // 文件里的文本会在这里被打印出来
            var workbook = new Excel.Workbook();
            workbook.xlsx.load(e.target.result)
                .then(function () {
                    let worksheet = workbook.getWorksheet(1);
                    let msg = "";
                    worksheet.eachRow(function (row, rowNumber) {
                        msg = msg + row.getCell(1) + ",";
                    });
                    console.log('msg', msg);
                    self.filevalue = msg.substring(0, msg.length - 1);
                    self.setService.sendEvent(self.sets.styles.nzSetValueId, "linkagesetValue", { value: self.filevalue })
                    self.isVisible = false;
                });
        };
    }

    Listening() {
        setTimeout(() => {
            this.setService.initEvent(this.blockid);
            this.setService.events[this.blockid].subscribe(
                data => {
                    console.log("Listening:", data['type'], JSON.stringify(data));
                    let array0 = []
                    let array1 = []
                    switch (data['type']) {
                        case 'pageShow':

                            console.log("data.datas.value", data.datas.value, data.datas.param0)
                            array0 = (data.datas.param0 + "").split(",");
                            array1 = (data.datas.param1 + "").split(",");
                            if (array0.indexOf(data.datas.value) >= 0) {
                                this.nzShow = false;
                            } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                                this.nzShow = true;
                            }
                            break;
   
                        default:
                            break;
                    }
                }
            )
        }, !this.static ? 100 : 0);


    }

}
